import { Select, SelectItem, SelectProps } from '@mantine/core';
import { useMemo } from 'react';

type RevisionPlanPropertySelectProps = Omit<SelectProps, 'data'>;

/**
 * Select for revision plan properties.
 */
export default function RevisionPlanPropertySelect(props: RevisionPlanPropertySelectProps) {
  const properties: SelectItem[] = useMemo(
    () =>
      [
        { value: 'externalId', label: 'Externé ID' },
        { value: 'deviceId', label: 'ID Zariadenia' },
        { value: 'type', label: 'Úkon' },
        { value: 'deviceTypeId', label: 'Skupina' },
        { value: 'nextRevision', label: 'Nasledujúci termín' },
        { value: 'period', label: 'Perióda (mesiace)' },
        { value: 'neverExecuted', label: 'Neevidujem dátum vykonania' },
      ] satisfies SelectItem[],
    []
  );

  return <Select data={properties} {...props} />;
}
